import { render } from "./ProgramEvaluationQuestionsListView.vue?vue&type=template&id=0f8c4cb1&scoped=true&ts=true"
import script from "./ProgramEvaluationQuestionsListView.vue?vue&type=script&lang=ts"
export * from "./ProgramEvaluationQuestionsListView.vue?vue&type=script&lang=ts"

import "./ProgramEvaluationQuestionsListView.vue?vue&type=style&index=0&id=0f8c4cb1&scoped=true&lang=css"

import exportComponent from "D:\\Ventla Code\\New Admin\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f8c4cb1"]])

export default __exports__